module.exports = __webpack_public_path__ + "static/media/plus.3357efc7.svg";